import React from 'react';
import L from 'leaflet';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from 'react-localize-redux';
import { Map as LeafletMap, Marker, TileLayer } from 'react-leaflet';
import { getHostApi } from '../../store/apiWrapper';
import { reportActions } from '../../store/reportStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import ContactRow from './contact/contactRow';
import AddressRow from './contact/addressRow';
import OldStyleSection from '../common/oldStyleSection';
import OldStyleTableWithHistory from '../common/oldStyleTableWithHistory';
import SanitizedLink from '../common/sanitizedLink';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png').default,
    iconUrl: require('leaflet/dist/images/marker-icon.png').default,
    shadowUrl: require('leaflet/dist/images/marker-shadow.png').default
});

class ContactData extends React.Component {
    get section() {
        return this.props.sections.find(o => o.id === this.props.sectionId);
    }

    get pageSize() {
        const limits = this.props.getSectionLimits(this.props.reportType, this.props.sectionId);
        return this.section.isLimited ? limits.pageSize.limited : limits.pageSize.unlimited;
    }

    shouldComponentUpdate(nextProps, _) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (isNullOrUndefined(this.props.data) ? "" : <div>{this.renderContent(this.props.data, this.props.dataHash)}</div>);
    }

    renderContent = (data, dataHash) => {
        let hasGeoData = !isNullOrUndefined(data.primaryAddress) && !isNullOrUndefined(data.primaryAddress.latitude) && !isNullOrUndefined(data.primaryAddress.longitude);
        return (<>
            {hasGeoData &&
                <div className="contact-data">
                    <LeafletMap scrollWheelZoom={false} center={[data.primaryAddress.latitude, data.primaryAddress.longitude]} zoom="13">
                        <TileLayer
                            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <Marker position={[data.primaryAddress.latitude, data.primaryAddress.longitude]} />
                    </LeafletMap>
                </div>
            }
            <div className='ident-data' style={{ flex: '1 0 auto' }}>
                {(data.primaryAddress || (Array.isArray(data.addressGroups) && data.addressGroups.length > 0)) && this.renderAddresses(data, dataHash)}
                {data.country === "CZ" ? this.renderContactsCz(data, dataHash) : this.renderContactsSk(data, dataHash)}
                {this.renderLinks(data)}
            </div>
            <br />
            {this.renderPremises(data.premisesActual || [], data.premisesHistorical || [], data.premisesActualCount, data.premisesHistoricalCount)}
        </>);
    }

    renderAddresses = (data, dataHash) => {
        return data.addressGroups.map(group => (
            <AddressRow key={group.header} group={group} dataHash={dataHash} />
        ))
    }

    renderContactsCz = (data, dataHash) => {
        return (
            <React.Fragment>
                {data.region && <div className='ident-item'>
                    <span className="bold"><Translate id="Report.ContactInformations.Region" /></span>
                    <span>{data.region}</span>
                </div>}
                <ContactRow data={data.phoneNumbers} dataHash={dataHash} links='phone' />
                <ContactRow data={data.faxNumbers} dataHash={dataHash} links='phone' />
                <ContactRow data={data.webs} dataHash={dataHash} links='web' />
                <ContactRow data={data.emails} dataHash={dataHash} />
                <ContactRow data={data.dataBoxes} dataHash={dataHash} />
            </React.Fragment>
        );
    }

    renderContactsSk = (data, dataHash) => {
        return (
            <React.Fragment>
                {data.region && <div className='ident-item'>
                    <span className="bold"><Translate id="Report.ContactInformations.Region" /></span>
                    <span>{data.region}</span>
                </div>}
                <ContactRow data={data.phoneNumbers} dataHash={dataHash} links='phone' />
                <ContactRow data={data.faxNumbers} dataHash={dataHash} links='phone' />
                <ContactRow data={data.domains} dataHash={dataHash} links='web' />
                <ContactRow data={data.webs} dataHash={dataHash} links='web' />
                <ContactRow data={data.emails} dataHash={dataHash} />
            </React.Fragment>
        );
    }

    renderPremises = (actual, historical, actualCount, historicalCount) => {
        return (
            <OldStyleSection name={this.props.translate("Report.ContactInformations.Premises")} hasData={actual.length > 0 || historical.length > 0} isBold>
                <OldStyleTableWithHistory stripped tableColumns={2} fixed={false}
                    resolveExpanded={this.props.resolveExpanded}
                    actualData={actual}
                    actualRow={(r) => this.renderPremiseRow(r.id, r.address, null, false)}
                    historyData={historical}
                    historyRow={(r) => this.renderPremiseRow(r.id, r.address, r.cancellationDateFormatted, true)}
                />
                {this.renderMoreLinks(actual, historical, actualCount, historicalCount)}
            </OldStyleSection>
        )
    }

    renderPremiseRow = (id, address, cancellationDate, history) => {
        return (
            <tr key={id} className={classnames("colorize", { "old-style-table-report-history-row": history })}>
                <td style={{ width: "70%" }}>{address}</td>
                <td style={{ width: "30%" }}>{!isNullOrUndefined(cancellationDate)
                    ? <>{this.props.translate("Report.ContactInformations.Premises.Cancelled")} {cancellationDate}</>
                    : null}
                </td>
            </tr>
        )
    }

    renderMoreLinks = (actual, historical, actualCount, historicalCount) => {
        if (actual.length < actualCount || historical.length < historicalCount) {
            return (
                <div>
                    {this.section.isLimited
                        ? <a href={this.props.getUnlimitedSectionLink(this.props.reportType, this.props.id, this.props.sectionId)}
                            target="_blank" className="link-functional">
                            <Translate id="Report.Common.ShowAll" />
                        </a>
                        : <span className="link-functional" onClick={() => this.getAll(this.pageSize, actualCount, historicalCount)} >
                            <Translate id="Report.Common.More" />
                        </span>}
                </div>
            )
        }
    }

    renderLinks = (data) => {
        return data.country === "CZ" ? this.renderCzechLinks(data.ico, data.companyName, data.esmTitle, data.rpvsSectionId, data.rpvsTitle) : this.renderSlovakLinks(data.ico, data.companyName, data.rpvsSectionId, data.rpvsTitle, data.isFop)
    }

    renderSlovakLinks = (ico, companyName, rpvsSectionId, rpvsTitle, isFop) => {
        let data = [
            { isFop: false, name: "ORSR", link: ico !== "" ? `http://www.orsr.sk/hladaj_ico.asp?ICO=${ico}` : `http://www.orsr.sk/hladaj_subjekt.asp?OBMENO=${companyName}`, title: this.props.translate("Report.ContactInfo.ORSR.Desc") },
            { isFop: undefined, name: "ŽRSR", link: "https://www.zrsr.sk/", title: `${this.props.translate("Report.ContactInfo.ZRSR.Desc")} -  ${this.props.translate("Report.Common.IndirectLink")}` },
            { isFop: undefined, name: this.props.translate("Report.ContactInfo.StatReg.Name"), link: "https://zber.statistics.sk/sk/register-organizacii?_sk_susr_isis_pub_organisations_register_portlet_OrganisationsRegisterPortlet_INSTANCE_puzm_navigationType=SEARCH_VIEW", title: `${this.props.translate("Report.ContactInfo.StatReg.Desc")} -  ${this.props.translate("Report.Common.IndirectLink")}` },
            { isFop: undefined, name: this.props.translate("Report.ContactInfo.LostAndStolen.Name"), link: "http://www.minv.sk/?stratene-a-odcudzene-doklady", title: this.props.translate("Report.ContactInfo.LostAndStolen.Desc") },
            { isFop: false, name: this.props.translate("Report.ContactInfo.Ruz"), link: `http://www.registeruz.sk/cruz-public/domain/accountingentity/simplesearch?accountingEntityName=${ico}`, title: this.props.translate("Report.ContactInfo.Ruz") },
            { isFop: undefined, name: this.props.translate("Links.Site.RPVS"), link: `https://rpvs.gov.sk/rpvs/Partner/Partner/Detail/${rpvsSectionId}`, title: rpvsTitle },
            { isFop: undefined, name: "Google", link: `http://www.google.sk/search?hl=sk&btnG=Vyhladat+Googlom&lr=lang_sk&q=${companyName}`, title: "Google" },
        ]

        return (
            <div className='ident-item'>
                <span className="bold">URL</span>
                <span>{data.filter(x => x.isFop === undefined || x.isFop === isFop).map((l, i) => [
                    i > 0 && ", ",
                    <SanitizedLink key={i} title={l.title} link={l.link} label={l.name} />
                ])} </span>
            </div>
        );
    }

    renderCzechLinks = (ico, companyName, esmTitle, rpvsSectionId, rpvsTitle) => {
        let data = [
            { name: "ARES", link: `https://ares.gov.cz/ekonomicke-subjekty?ico=${ico}` },
            { name: this.props.translate("Report.ContactInfo.Csu"), link: `https://apl.czso.cz/res/detail?ico=${ico}` },
            { name: this.props.translate("Report.ContactInfo.Bankruptcy"), link: `https://upadci.justice.cz/p_i6.php?vyber=0&nazev=&ico=${ico}&obec=&senat=&ktyp=&znacka=&rok=&soud=&MAXPOC=50&TYP_SORT=0&stav=&od=&do=&akce=&aod=&ado=&fprijmeni=&frc=&prijmeni=` },
            { name: this.props.translate("Report.ContactInfo.Insolvency"), link: `https://isir.justice.cz/isir/ueu/vysledek_lustrace.do?nazev_osoby=&vyhledat_pouze_podle_zacatku=on&jmeno_osoby=&ic=${ico}&datum_narozeni=&rc=&mesto=&cislo_senatu=&bc_vec=&rocnik=&id_osoby_puvodce=&druh_stav_konkursu=&datum_stav_od=&datum_stav_do=&aktualnost=AKTUALNI_I_UKONCENA&druh_kod_udalost=&datum_akce_od=&datum_akce_do=&nazev_osoby_f=&nazev_osoby_spravce=&rowsAtOnce=50&spis_znacky_datum=&spis_znacky_obdobi=14DNI` },
            { name: this.props.translate("Report.ContactInfo.Justice"), link: `https://or.justice.cz/ias/ui/rejstrik-$firma?%3Asubmit=x&.%2Frejstrik-%24firma=&nazev=&ico=${ico}&obec=&ulice=&forma=&oddil=&vlozka=&soud=&polozek=50&typHledani=STARTS_WITH&jenPlatne=VSECHNY` },
            { name: "Google", link: `http://www.google.cz/search?hl=cs&btnG=Vyhledat+Googlem&lr=lang_cs&q=${companyName}` },
            { name: this.props.translate("Report.ContactInfo.Rzp"), link: `https://www.rzp.cz/verejne-udaje/cs/udaje/vyber-subjektu;ico=${ico};roleSubjektu=P;platne=false` },
            { name: this.props.translate("Links.Site.ESM"), link: `https://esm.justice.cz/ias/issm/rejstrik-$sm?p%3A%3Asubmit=x&ico=${ico}`, title: esmTitle }
        ]

        if (!isNullOrUndefined(rpvsSectionId)) {
            data.push({ name: this.props.translate("Links.Site.RPVS"), link: `https://rpvs.gov.sk/rpvs/Partner/Partner/Detail/${rpvsSectionId}`, title: rpvsTitle });
        }

        return (
            <div className='ident-item'>
                <span className="bold">URL</span>
                <span>{data.map((l, i) => [
                    i > 0 && ", ",
                    <SanitizedLink key={i} title={l.title} link={l.link} label={l.name} />
                ])} </span>
            </div>
        )
    }

    concatData = (_hint, oldData, newData) => {
        const actual = oldData.premisesActualCount === newData.totalCount;
        return actual
            ? { ...oldData, premisesActual: [...oldData.premisesActual, ...newData.items] }
            : { ...oldData, premisesHistorical: [...oldData.premisesHistorical, ...newData.items] };
    }

    getAll = (offset, actual, historical) => {
        if (actual > offset)
            this.getMore(offset, actual - offset, true);
        if (historical > offset)
            this.getMore(offset, historical - offset, false);
    }

    getMore = (offset, count, active) => {
        this.props.fetchMoreData(
            [this.props.sectionId],
            { count: count, offset: offset, active: active, report: this.props.reportType },
            null,
            this.concatData,
            null,
            `${getHostApi()}/api/report/${this.props.id}/trading-premises`
        );
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(ContactData));